/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { integrationSyncFailedItemDtoSchema } from './integrationSyncFailedItemDtoSchema';

export const syncFailedItemsPageResponseSchema = z.object({
  get items() {
    return z
      .array(integrationSyncFailedItemDtoSchema)
      .describe('Page of sync failed items, ordered most recent first.');
  },
  totalCount: z
    .int()
    .describe('Total number of sync failed items matching the query, across all pages.'),
});
